(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/react/shared-components/navigation.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/react/shared-components/navigation.js');

'use strict';

const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  BallItem = _svs$ui$ReactItemsMen.BallItem;
const NavLink = svs.app.ReactRouter.NavLink;
const Icon = svs.ui.ReactIcon;
const Brand = svs.ui.ReactBrand;
const FirstNavItem = () => React.createElement(NavLink, {
  exact: true,
  tabIndex: "-1",
  title: "Alla",
  to: "/"
}, React.createElement(BallItem, {
  className: "fg-icon-ball-item",
  label: "Alla",
  to: "/"
}, React.createElement(Icon, {
  color: "fc-white",
  icon: "andelsspel"
})));
const ProductNavItem = _ref => {
  let productName = _ref.productName,
    to = _ref.to,
    backgroundClass = _ref.backgroundClass;
  return React.createElement(NavLink, {
    tabIndex: "-1",
    title: productName,
    to: to
  }, React.createElement(BallItem, {
    label: productName
  }, React.createElement(Brand, {
    brand: productName,
    className: backgroundClass
  })));
};
const ProductNavItems = _ref2 => {
  let items = _ref2.items;
  return items.map(_ref3 => {
    let productName = _ref3.productName,
      to = _ref3.to,
      backgroundClass = _ref3.backgroundClass;
    return React.createElement(ProductNavItem, {
      backgroundClass: backgroundClass,
      key: productName,
      productName: productName,
      to: to
    });
  });
};
const Navigation = _ref4 => {
  let navItems = _ref4.navItems;
  return React.createElement(ItemsMenu, {
    branding: "fractiongames",
    centered: true,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, React.createElement(FirstNavItem, null), React.createElement(ProductNavItems, {
    items: navItems
  }));
};
svs.fractiongames.components.Navigation = Navigation;

 })(window);